// @flow
import React from 'react'
import { CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { green } from '@material-ui/core/colors'

function LoadingButton({
  loading,
  children
}: {
  loading: boolean,
  children: React.Node
}) {
  const classes = useStyles()

  return (
    <div className={classes.wrapper}>
      {children}
      {loading && (
        <CircularProgress size={24} className={classes.buttonProgress} />
      )}
    </div>
  )
}

const useStyles = makeStyles(() => ({
  wrapper: {
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  }
}))

export default LoadingButton
